import { parseApiDateUtc } from '@/lib/api-date'
import type { ProjectRow, TicketListItem } from '@/types/api'

export type TicketListHighlightKind = 'fire' | 'alarm'

export type TicketListHighlightItem = {
  kind: TicketListHighlightKind
  title: string
}

/**
 * Иконки 🔥 / ⏰ в колонке статуса — как в классическом интерфейсе (`getTicketFireIcons`).
 * Учитываются флаги проекта и пороги в минутах.
 */
export function ticketListHighlightIcons(
  t: TicketListItem,
  project: ProjectRow | undefined,
): TicketListHighlightItem[] {
  const out: TicketListHighlightItem[] = []
  if (!project) return out

  const status = (t.status || '').toLowerCase()
  if (status === 'resolved' || status === 'closed') return out

  const now = Date.now()

  if (project.enable_highlight_new_tickets && status === 'new') {
    const created = parseApiDateUtc(t.created_at)
    if (created) {
      const minutes = (now - created.getTime()) / (1000 * 60)
      const threshold = project.highlight_new_tickets_after_hours ?? 1
      if (minutes >= threshold) {
        out.push({
          kind: 'fire',
          title: `Новое обращение без ответа более ${threshold} мин`,
        })
      }
    }
  }

  if (
    project.enable_highlight_customer_replies &&
    t.last_update_by &&
    String(t.last_update_by).toLowerCase() === 'customer' &&
    t.last_update_at
  ) {
    const last = parseApiDateUtc(t.last_update_at)
    if (last) {
      const minutes = (now - last.getTime()) / (1000 * 60)
      const threshold = project.highlight_customer_replies_after_hours ?? 1
      if (minutes >= threshold) {
        out.push({
          kind: 'alarm',
          title: `Нет ответа оператора более ${threshold} мин`,
        })
      }
    }
  }

  return out
}
